import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom"; // ✅ Add this
import { initConsoleFilter } from "./Utils/consoleFilter";

// Suppress noisy 3rd party console messages
initConsoleFilter();

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <BrowserRouter>
        {" "}
        {/* ✅ Wrap here */}
        <App />
      </BrowserRouter>
    </Provider>
  </QueryClientProvider>,
);

reportWebVitals();
